<template>
  <div class="terms-content">
    <p>
      Selamat datang di <a href="https://efunding.id/">efunding.id</a>
    </p>
    <p>
      Disarankan sebelum mengakses Situs ini lebih jauh, Pengguna terlebih dahulu membaca dan memahami syarat
      dan ketentuan yang berlaku. Syarat dan ketentuan berikut adalah ketentuan dalam pengunjungan Situs, isi
      dan/atau konten, layanan, serta fitur lainnya yang ada di dalam Situs. Dengan mengakses atau menggunakan
      Situs atau aplikasi lainnya yang disediakan oleh atau dalam Situs, berarti Pengguna telah memahami dan
      menyetujui serta terikat dan tunduk dengan segala syarat dan ketentuan yang berlaku di Situs
      ini.Disarankan sebelum mengakses Situs ini lebih jauh, Pengguna terlebih dahulu membaca dan memahami
      syarat dan ketentuan yang berlaku. Syarat dan ketentuan berikut adalah ketentuan dalam pengunjungan Situs,
      isi dan/atau konten, layanan, serta fitur lainnya yang ada di dalam Situs. Dengan mengakses atau
      menggunakan Situs atau aplikasi lainnya yang disediakan oleh atau dalam Situs, berarti Pengguna telah
      memahami dan menyetujui serta terikat dan tunduk dengan segala syarat dan ketentuan yang berlaku di Situs
      ini.
    </p>

    <h3><strong>1. DEFINISI</strong></h3>
    <p>Setiap kata atau istilah berikut yang digunakan di dalam Syarat dan Ketentuan ini memiliki arti seperti
      berikut di bawah, kecuali jika kata atau istilah yang bersangkutan di dalam pemakaiannya dengan tegas
      menentukan lain</p>
    <p><strong>1.1. "Kami",</strong> berarti PT Efunding Teknologi Keuangan selaku pemilik dan pengelola Situs
      serta aplikasi <em>mobile</em> yang bernama efunding.</p>
    <p><strong>1.2. "Anda",</strong> berarti tiap orang yang mengakses Situs dan menggunakan layanan dan jasa
      yang disediakan oleh Kami.</p>
    <p><strong>1.3. "Layanan",</strong> berarti setiap dan keseluruhan jasa serta informasi yang ada pada Situs,
      termasuk namun tidak terbatas pada informasi yang disediakan, fitur dan layanan aplikasi, dukungan data,
      serta aplikasi <em>mobile</em> yang Kami sediakan.</p>
    <p><strong>1.4. "Pengguna",</strong> berarti tiap orang yang mengakses dan menggunakan layanan dan jasa yang
      disediakan oleh Kami, termasuk diantaranya Pengguna Belum Terdaftar dan Pengguna Terdaftar.</p>
    <p><strong>1.5. "Pengguna Belum Terdaftar",</strong> berarti tiap orang yang mengakses Situs Kami dan belum
      melakukan registrasi.</p>
    <p><strong>1.6. "Pengguna Terdaftar",</strong> berarti tiap orang yang mengakses dan menggunakan layanan dan
      jasa yang disediakan oleh Kami, serta telah melakukan registrasi dan memiliki akun pada Situs Kami.</p>
    <p><strong>1.7. "Pihak Ketiga",</strong>berarti pihak lainnya, termasuk namun tidak terbatas pihak bank,
      <em>multifinance</em>, <em>peer to peer lending</em>, broker dan penyedia layanan asuransi, agen penjual
      efek reksa dana, transfer dana, telekomunikasi yang menyediakan layanannya dalam Situs.</p>
    <p><strong>1.8. "Informasi Pribadi",</strong> berarti tiap dan seluruh data pribadi yang diberikan oleh
      Pengguna di Situs Kami, termasuk namun tidak terbatas pada nama lengkap, tempat dan tanggal lahir, jenis
      kelamin, alamat, nomor identitas, informasi debitur, kartu keluarga, akta kelahiran, surat nikah, akta,
      bukti kepemilikan, KTP, NPWP, surat izin usaha, surat penjaminan, data penghasilan, lokasi pengguna,
      kontak pengguna, serta dokumen dan data pendukung lainnya sebagaimana diminta pada ringkasan pendaftaran
      akun serta pada ringkasan aplikasi pengajuan.</p>
    <p><strong>1.9. "Konten",</strong> berarti teks, data, informasi, angka, gambar, grafik, foto, audio, video,
      nama pengguna, informasi, aplikasi, tautan, komentar, peringkat, desain, atau materi lainnya yang
      ditampilkan pada Situs.</p>
    <p><strong>1.10. "Situs",</strong> berarti efunding.id</p>

    <h3><strong>2. LAYANAN DAN/ATAU JASA</strong></h3>
    <p>Kami memberikan informasi mengenai produk-produk finansial dan/atau perbankan, asuransi, telekomunikasi
      yang disediakan oleh Pihak Ketiga. Layanan ini memungkinkan Anda untuk dapat melihat, menelaah, membaca,
      serta membandingkan informasi tersebut.</p>
    <p><strong>2.1.</strong> Informasi yang terdapat dalam Situs Kami ditampilkan sesuai keadaan kenyataan untuk
      tujuan informasi umum. Kami berusaha untuk selalu menyediakan dan menampilkan informasi yang terbaru dan
      akurat, namun Kami tidak menjamin bahwa segala informasi sesuai dengan ketepatan waktu atau relevansi
      dengan kebutuhan Anda.</p>
    <p><strong>2.2.</strong> Diharapkan Anda tidak menganggap atau berasumsi bahwa Situs ini dapat dijadikan
      sebagai saran keuangan dan/atau finansial, atau rekomendasi atas produk serta layanan yang ditampilkan.
      Informasi di Situs ini disediakan untuk membantu Anda dalam memilih produk atau layanan yang sesuai dengan
      kebutuhan Anda. Anda sepenuhnya bertanggung jawab atas keputusan terkait pemilihan produk dan layanan,
      atau dalam menandatangani kontrak berkaitan dengan sebuah produk atau layanan. Dengan memberikan Kami
      rincian tentang diri pribadi Anda, dianggap Anda mengajukan diri untuk mendapatkan suatu produk atau
      layanan tertentu.</p>
    <p><strong>2.3.</strong> Layanan yang Kami berikan tidak bersifat memaksa atau mengikat, serta tidak
      mengharuskan Anda untuk mengikuti informasi yang tersedia. Tidak ada situasi atau keadaan apapun yang
      dapat membuat Kami dikenakan tanggung jawab atas kemungkinan kerugian yang Anda alami karena pengambilan
      keputusan yang dilakukan oleh Anda sendiri terkait tindakan atas informasi produk yang kami sampaikan di
      Situs.</p>
    <p><strong>2.4.</strong> Kami memiliki hak untuk kapan saja menampilkan, mengubah, menghapus, menghilangkan,
      atau menambahkan segala konten yang ditampilkan dalam Situs ini.</p>

    <h3><strong>3. PENGGUNAAN LAYANAN DAN JASA</strong></h3>
    <p>Dengan Anda melanjutkan penggunaan atau pengaksesan Situs ini, berarti Anda telah menyatakan serta
      menjamin kepada Kami bahwa :</p>
    <p><strong>3.1.</strong> Anda hanya diperkenankan untuk mengakses dan/atau menggunakan Situs ini untuk
      keperluan pribadi dan non-komersil, yang berarti bahwa Situs ini hanya boleh diakses dan digunakan secara
      langsung oleh individu atau bisnis yang sedang mencari produk atau layanan untuk individu atau bisnis
      tersebut. Akses dan penggunaan Situs diluar dari keperluan pribadi atau non-komersil dilarang keras, dan
      melanggar Syarat dan Ketentuan ini.</p>
    <p><strong>3.2.</strong> Anda tidak diperkenankan menggunakan Situs dalam hal sebagai berikut :</p>
    <p>
      <ul>
        <li>Untuk menyakiti, menyiksa, mempermalukan, memfitnah, mencemarkan nama baik, mengancam, mengintimidasi
          atau mengganggu orang atau bisnis lain, atau apapun yang melanggar privasi atau yang Kami anggap cabul,
          menghina, penuh kebencian, tidak senonoh, tidak patut, tidak pantas, tidak dapat diterima,
          mendiskriminasikan atau merusak.</li>
        <li>Dalam cara yang melawan hukum, tindakan penipuan atau tindakan komersil.</li>
        <li>Melanggar atau menyalahi hak orang lain, termasuk tanpa kecuali : hak paten, merek dagang, hak cipta,
          rahasia dagang, publisitas, dan hak milik lainnya.</li>
        <li>Untuk membuat, memeriksa, memperbarui, mengubah atau memperbaiki database, rekaman atau direktori Anda
          ataupun orang lain.</li>
        <li>Mengubah atau mengatur ulang bagian apapun dalam Situs ini yang akan mengganggu atau menaruh beban
          berlebihan pada sistem komunikasi dan teknis kami.</li>
        <li>Mengunakan kode komputer otomatis, proses, program, robot, net crawler, spider, pemrosesan data,
          trawling atau kode komputer, proses, program atau sistem <em>screen scraping</em> alternatif.</li>
        <li>Melanggar Syarat dan Ketentuan, atau petunjuk lainnya yang ada pada Situs.</li>
      </ul>
    </p>
    <p><strong>3.3.</strong> Kami tidak bertanggung jawab atas kehilangan akibat kegagalan mengakses Situs, dan
      metode penggunaan Situs yang diluar kendali Kami.</p>
    <p><strong>3.4.</strong> Kami tidak bertanggung jawab atau dapat dipersalahkan atas kehilangan atau
      kerusakan yang diluar perkiraan saat Anda mengakses atau menggunakan Situs ini. Ini termasuk kehilangan
      penghematan yang diharapkan, kehilangan bisnis atau kesempatan bisnis, kehilangan pemasukan atau
      keuntungan, atau kehilangan atau kerusakan apapun yang Anda harus alami akibat penggunaan Situs ini.</p>
    <h3><strong>4. HAK INTELEKTUAL PROPERTI</strong></h3>
    <p>Semua Hak Kekayaan Intelektual yang ada di dalam Situs ini adalah milik Kami. Tiap atau keseluruhan
      informasi dan materi dan konten, termasuk namun tidak terbatas pada tulisan, perangkat lunak, teks, data,
      grafik, gambar, audio, video, logo, ikon atau kode-kode html dan kode-kode lain yang ada di Situs ini
      dilarang dipublikasikan, dimodifikasi, disalin, digandakan atau diubah dengan cara apapun di luar area
      Situs ini tanpa izin dari Kami. Pelanggaran terhadap hak-hak Situs ini dapat ditindak sesuai dengan
      peraturan yang berlaku.</p>
    <p>Anda dapat menggunakan informasi atau isi dalam Situs hanya untuk penggunaan pribadi non-komersil.
      Kecuali ditentukan sebaliknya dan/atau diperbolehkan secara tegas oleh undang-undang hak cipta, maka
      Pengguna dilarang untuk menyalin, membagikan ulang, mentransmisi ulang, meretas, mempublikasi atau
      melakukan tindakan eksploitasi komersial dari pengunduhan yang dilakukan tanpa seizin Kami sebagai pemilik
      Hak Intelektual Properti tersebut. Dalam hal Pengguna telah mendapatkan izin yang diperlukan maka Pengguna
      dilarang melakukan perubahan atau penghapusan. Pengguna dengan ini menyatakan menerima dan mengetahui
      bahwa dengan mengunduh materi Hak Intelektual Properti bukan berarti mendapatkan hak kepemilikan atas
      pengunduhan materi Hak Intelektual Properti tersebut.</p>
    <h3><strong>5. KOMENTAR</strong></h3>
    <p>Jika Anda ingin memberikan komentar, masukan, ataupun sanggahan mengenai tiap atau keseluruhan konten dan
      informasi dalam Situs, Kami juga menyediakan sarana chat/messaging, kontak email, blog, ataupun media
      sosial milik Kami. Anda diperbolehkan untuk memberi komentar, dan setuju bahwa jika diperlukan, akan Kami
      pergunakan untuk kepentingan informasi dan ditampilkan pada Situs Kami. Dan harap diperhatikan bahwa
      komentar, masukan, atau sanggahan yang Anda berikan tidak boleh bertentangan dengan Syarat dan Ketentuan
      ini, terutama seperti tercantum dalam poin <strong>3.2.</strong></p>
    <h3><strong>6 PENGAJUAN</strong></h3>
    <p><strong>6.1.</strong> Anda bisa mengajukan diri untuk mendapatkan berbagai produk dan layanan seperti
      yang ditampilkan di Situs ini. Produk dan layanan tersebut disediakan oleh Pihak Ketiga. Anda sepenuhnya
      bertanggung jawab atas pilihan produk atau layanan, dan Kami tidak bertanggung jawab atau dapat
      dipersalahkan atas kehilangan atau kerusakan yang mungkin Anda derita akibat produk atau layanan yang Anda
      dapatkan saat menggunakan Situs ini, atau atas tindakan, penghapusan atau kesalahan Pihak Ketiga yang
      disebut di produk atau layanan itu.</p>
    <p><strong>6.2.</strong> Diingatkan kembali bahwa data dan deskripsi produk dan jasa pada Situs ini mungkin
      tidak mewakili seluruh deskripsi dari semua pilihan dan persyaratan produk dan layanan tersebut. Anda
      perlu berhati-hati dan cermat untuk melihat semua pilihan dan syarat dan kondisi dari setiap produk atau
      jasa sebelum melakukan pengajuan.</p>
    <p><strong>6.3.</strong> Jika Anda mengajukan permohonan dan mendapatkan produk atau layanan, Anda akan
      masuk ke dalam kontak dengan Pihak Ketiga sebagai penyedia produk atau layanan, yang memiliki syarat dan
      ketentuan sendiri. Anda bertanggung jawab untuk memastikan bahwa Anda setuju dengan syarat dan kondisi
      sebelum memasuki kontrak untuk mendapatkan produk atau layanan dimaksud. Kami tidak bertanggung jawab atau
      disalahkan atas segala kerugian atau kerusakan yang mungkin Anda derita akibat syarat dan ketentuan yang
      berlaku di setiap kontrak antara Anda dengan Pihak Ketiga, termasuk yang berhubungan tindakan, kelalaian
      atau kesalahan dari Pihak Ketiga.</p>
    <p><strong>6.4.</strong> Anda memberikan izin kepada Efunding untuk menggunakan, mengolah dan/atau
      menyerahkan Informasi Pribadi milik Anda yang telah diberikan kepada Efunding termasuk namun tidak
      terbatas pada Penyelengara e-KYC, Penyelenggara Tanda Tangan Digital, Lembaga Keuangan Syariah yang
      dipilih dan penyedia jasa lainnya, serta <em>channel</em> lainnya untuk pemasaran dari produk maupun
      layanan yang disediakan oleh Pihak Ketiga pada Situs.</p>
    <p><strong>6.5.</strong> Anda memberikan izin pada Kami untuk memproses data Anda untuk meningkatkan layanan
      Kami dalam bentuk apapun, termasuk tapi tidak terbatas untuk keperluan pemasaran dan peningkatan layanan
      Kami.</p>
    <h3><strong>7. TAUTAN LAINNYA</strong></h3>
    <p>Situs Kami mungkin menyediakan beberapa tautan tertentu yang merujuk atau mengarahkan Anda ke laman dari
      situs Pihak Ketiga, juga termasuk di dalamnya tautan yang tersedia pada halaman hasil pencarian produk
      tertentu. Anda mengetahui, memahami, serta menyetujui bahwa Kami tidak bertanggung jawab atas konten
      dan/atau materi lainnya yang terdapat dalam tautan milik Pihak Ketiga tersebut. Anda bertanggung jawab
      atas resiko ketika mengakses dan menggunakan tautan milik Pihak Ketiga tersebut. Dan disarankan Anda juga
      dapat membaca serta memahami isi dari Syarat dan Ketentuan yang berlaku di tautan milik Pihak Ketiga
      tersebut.</p>
    <h3><strong>8. PENGGUNA TERDAFTAR</strong></h3>
    <p><strong>8.1.</strong> Sebelum menjadi Pengguna Terdaftar, Pengguna diwajibkan membuat akun untuk diri
      Pengguna. Proses pembuatan akun dapat dilakukan secara online melalui Situs.</p>
    <p><strong>8.2.</strong> Sebelum menjadi Pengguna Terdaftar, Pengguna diwajibkan membaca, memahami, dan
      mematuhi Syarat dan Ketentuan serta Kebijakan Privasi yang berlaku di Situs.</p>
    <p><strong>8.3.</strong> Pengguna diharuskan memberi data Informasi Pribadi yang sebenarnya dan tidak
      memberikan informasi menyimpang dan/atau informasi yang tidak relevan dalam melakukan proses registrasi
      menjadi Pengguna Terdaftar. Selain itu Pengguna juga diharuskan memberi kontak detail yang benar dan
      valid.</p>
    <p><strong>8.4.</strong> Kami berhak untuk tidak memproses registrasi Pengguna yang tidak memenuhi
      persyaratan ataupun tidak memberikan informasi yang benar dan valid, dan Kami berhak juga mengeluarkan
      Pengguna Terdaftar dari keanggotaan jika di kemudian hari ditemukan hal-hal yang melanggar ketentuan dari
      Kami.</p>
    <p><strong>8.5.</strong> Semua Pengguna Terdaftar wajib mematuhi Syarat dan Ketentuan yang berlaku di Situs
      ini, dan tidak diperkenankan melakukan tindakan-tindakan seperti tertuang dalam poin <strong>3.2.</strong>
    </p>
    <h3><strong>9. KEADAAN MEMAKSA <em>(Force Majeure)</em></strong></h3>
    <p><strong>9.1.</strong> Keadaan memaksa adalah suatu kondisi atau kejadian yang berada di luar kendali
      manusia dan yang tidak dapat diantisipasi atau dihindari baik oleh Kami dan/atau Pengguna yang dapat
      menggagalkan atau menghalangi pelaksanaan kewajiban Kami dan/atau Pengguna. Keadaan tersebut termasuk
      namun tidak terbatas pada bencana alam, perang, konflik bersenjata, tindakan pemerintah (termasuk
      perubahan dalam peraturan perundang-undangan yang berlaku), kerusuhan sipil, gangguan aliran listrik yang
      signifikan, serangan siber yang signifikan, epidemi ataupun pandemi, tindakan teroris, dan kejadian atau
      kondisi lain.</p>
    <p><strong>9.2.</strong> Para Pihak dibebaskan dari kewajibannya selama keadaan memaksa tersebut terjadi.
    </p>
    <p><strong>9.3.</strong> Para Pihak yang terkena dampak keadaan memaksa harus memberikan pemberitahuan
      tertulis atau secara elektronik kepada pihak lainnya selambat-lambatnya 3 (tiga) hari kalender sejak
      terjadinya keadaan memaksa, yang mencakup deskripsi tentang keadaan memaksa, alasan mengapa kewajibannya
      terdampak, dan perkiraan durasi keadaan memaksa.</p>
    <p><strong>9.4.</strong> Apabila keadaan memaksa berlangsung atau berlanjut lebih dari 30 (tiga puluh) hari
      kalender berturut-turut, Para Pihak akan memiliki hak untuk menentukan keberlangsungan dari Perjanjian
      yang mengikatnya.</p>
    <p><strong>9.5.</strong> Para Pihak yang terkena dampak keadaan memaksa harus melakukan upaya terbaik yang
      wajar untuk mengurangi dampak kerugian bagi Para Pihak dan/atau untuk memenuhi kewajibannya.</p>
    <h3><strong>10. UMUM</strong></h3>
    <p><strong>10.1.</strong> Penggunaan dan akses ke Situs ini diatur oleh Syarat dan Ketentuan serta Kebijakan
      Privasi Kami. Dengan mengakses atau menggunakan Situs ini, informasi, atau aplikasi lainnya dalam bentuk
      aplikasi <em>mobile</em> yang disediakan dalam Situs, berarti Anda telah memahami, menyetujui serta
      terikat dan tunduk dengan segala syarat dan ketentuan yang berlaku di Situs ini.</p>
    <p><strong>10.2.</strong> Kami berhak untuk menutup atau mengubah atau memperbaharui Syarat dan Ketentuan
      ini setiap saat tanpa pemberitahuan, dan berhak untuk membuat keputusan akhir jika tidak ada
      ketidakcocokan. Kami tidak bertanggung jawab atas kerugian dalam bentuk apa pun yang timbul akibat
      perubahan pada Syarat dan Ketentuan.</p>
    <p><strong>10.3.</strong> Pengguna memahami bahwa Pengguna telah mengizinkan Efunding untuk mengumpulkan
      informasi-informasi tentang Pengguna, termasuk namun tidak terbatas pada <em>IP address</em> dan
      <em>hardware</em> Pengguna sejak Pengguna mengunjungi dan mengakses Platform</p>
    <p><strong>10.4.</strong> Jika Anda masih memerlukan jawaban atas pertanyaan yang tidak terdapat dalam
      Syarat dan Ketentuan ini, Anda dapat menghubungi Kami di email <a
        href="mailto:support@efunding.id">support@efunding.id</a> atau menghubungi Kkami di nomor +62 818-227-070</p>
    <p><strong>10.5.</strong> Selain itu Anda juga dapat membaca <a
        href="https://efunding.id/faq"><em>Frequently Asked Question</em> (FAQ)</a> yang telah kami siapkan
      untuk menjawab seputar pertanyaan-pertanyaan umum.</p>
  </div>
</template>

<script>
export default {
  name: 'TermsContent'
}
</script>
<style scoped>
.terms-content {
  padding: 0 1.5rem;
  box-sizing: border-box;
  width: 100%;
}

.terms-content p {
  text-align: justify;
  margin-bottom: 1rem;
}

.authentication-form p {
  width: 100%;
  margin: 0 auto 30px;
}

.terms-content ul {
  list-style: none;
  padding-left: 2.5rem;
}

.terms-content ul li::before {
  content: '•';
  color: #333;
  display: inline-block;
  width: 1rem;
  margin-left: -1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/TermsContent.vue